// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"872acc31","359":"54b4b10e","549":"7e007989","592":"1233191b","614":"404eac96"}[chunkId] + ".chunk.js";
};